<mat-sidenav-container>

  <mat-sidenav-content [ngClass]="sidenav.opened ? 'sidenav-opened':'sidenav-closed mx-0'">
    <div class="mobile-top-bar d-flex align-items-center" (scroll)="onScrollEvent($event)"
      [ngClass]=" {'fixed' : (scrollOffset > 0)} ">
      <div class="col p-0 d-flex align-items-center topbar-left">
        <button class="mb-2" mat-icon-button (click)="sidenav.toggle()"><i class="fas fa-bars fa-xs"></i></button>
        <a routerLink="/">
          <img src="{{ logoLightUrl }}" alt="logo" class="logo-light">
        </a>
      </div>
      <div class="col p-0 d-flex align-items-center justify-content-end topbar-right">
        <button mat-button class="topbar-user-btn" [matMenuTriggerFor]="menu">
          <mat-icon>person</mat-icon><span class="ml-2">{{user.name}}</span><mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu" class="wide-menu" xPosition="before">
          <div *csHasPermission="RolePermission.PUBLISHER_DASHBOARD_READ">
            @for (pub of publishers; track pub) {
              <button mat-menu-item (click)="openDashboard('publisher', pub.id, pub.secondaryId)">
                <i class="far fa-fw fa-house-user"></i>
                <span class="ml-2">{{pub.name}}</span>
              </button>
            }
          </div>
          <div *csHasPermission="RolePermission.ADVERTISER_READ">
            @if (user?.advertiserId) {
              <button mat-menu-item (click)="openDashboard('advertiser', advertiser?.id)">
                <i class="fa fa-users"></i>
                <span class="ml-2">{{advertiser?.name}}</span>
              </button>
            }
          </div>
          <button mat-menu-item (click)="logout()" class="sign-out-button">
            <i class="far fa-fw fa-sign-out text-danger"></i>
            <span class="ml-2 text-danger">Sign out</span>
          </button>
        </mat-menu>
      </div>
    </div>
    <main class="main">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>

  <mat-sidenav [mode]="(screenWidth > 992) ? 'side' : 'over'" [opened]="!screenWidth || screenWidth > 992"
    [class.sideOpened]="sidenav.opened" [class.sideClosed]="!sidenav.opened" #sidenav>

    <div class="sidenav-menu">
      <div class="mt-md-5 pt-md-3"></div>
      <!-- ADMIN USER-->
      @if (UI.isAdmin || UI.isUser || UI.isReadOnlyAdmin || UI.isReadOnlyUser) {
        <mat-accordion class="app-nav-accordion" #accordion="matAccordion" [multi]="true"
          >
          <div *csHasPermission="RolePermission.HOME_READ">
            <div  (click)="closeSidenavMobile(sidenav);">
              <a class="sidenav-menu-item" routerLink="/dashboard" routerLinkActive="active">
                <i class="far fa-house-chimney"></i>
                <span>Home</span>
              </a>
            </div>
          </div>
          <div *csHasPermission="RolePermission.SUPPLY_READ">
            <mat-expansion-panel  class="mat-elevation-z0" [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title class="sidenav-menu-item">
                  <i class="far fa-boxes"></i>
                  <span>Supply</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                <li *csHasPermission="RolePermission.SUPPLY_PUBLISHERS_READ">
                  <a routerLink="/publishers" routerLinkActive="active">
                    <i class="fa-regular fa-circle" matTooltip="Publishers"></i>
                    <span>Publishers</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.SUPPLY_PLACEMENTS_READ">
                  <a routerLink="/placements" routerLinkActive="active">
                    <i class="fa-regular fa-circle" matTooltip="Placements"></i>
                    <span>Placements</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.SUPPLY_APPS_READ">
                  <a routerLink="/apps" routerLinkActive="active">
                    <i class="fa-regular fa-circle" matTooltip="Apps"></i>
                    <span>Apps</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.DEMAND_COMPLIANCE_READ">
                  <a routerLinkActive="active" routerLink="/demand/compliance">
                    <i class="fa-regular fa-circle" matTooltip="Domains"></i>
                    <span>Domains</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.TARGETING_READ">
                  <a routerLink="/supply-lists" routerLinkActive="active">
                    <i class="fa-regular fa-circle" matTooltip="Supply lists"></i>
                    <span>Supply lists</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.SUPPLY_ADS_TXT_READ">
                  <a routerLinkActive="active" routerLink="/ads-txt">
                    <i class="fa-regular fa-circle" matTooltip="Ads.txt"></i>
                    <span>Ads.txt</span>
                  </a>
                </li>
                <li *csHasPermission="[RolePermission.BLOCKLIST_ADVERTISERS_READ, RolePermission.BLOCKLIST_CREATIVES_READ]">
                  <a routerLinkActive="active" routerLink="/block-list/supply">
                    <i class="fa-regular fa-circle" matTooltip="Supply Block List"></i>
                    <span>Supply Block List</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.SUPPLY_ENDPOINT_GENERATOR_READ" [hidden]="true">
                  <a routerLinkActive="active" routerLink="/endpoint-generator">
                    <i class="fa-regular fa-circle" matTooltip="Endpoint generator"></i>
                    <span>Endpoint generator</span>
                  </a>
                </li>
              </ul>
            </mat-expansion-panel>
          </div>
          <div *csHasPermission="RolePermission.DEMAND_READ">
            <mat-expansion-panel  class="mat-elevation-z0" [expanded]="false">
              <mat-expansion-panel-header>
                <mat-panel-title class="sidenav-menu-item">
                  <i class="far fa-handshake"></i>
                  Demand
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                <li *csHasPermission="RolePermission.DEMAND_PARTNERS_READ">
                  <a routerLinkActive="active" routerLink="/demand/list">
                    <i class="fa-regular fa-circle" matTooltip="Partners"></i>
                    <span>Partners</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.DEMAND_PARTNERS_READ">
                  <a routerLinkActive="active" routerLink="/dsp">
                    <i class="fa-regular fa-circle" matTooltip="DSP"></i>
                    <span>DSP</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.DEMAND_CONNECTIONS_READ">
                  <a routerLinkActive="active" routerLink="/integrations">
                    <i class="fa-regular fa-circle" matTooltip="Demand Integrations"></i>
                    <span>Integrations</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.DEMAND_DEALS_READ">
                  <a routerLinkActive="active" routerLink="/deals">
                    <i class="fa-regular fa-circle" matTooltip="Deals"></i>
                    <span>Deals</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.BLOCKLIST_DSPS_READ">
                  <a routerLinkActive="active" routerLink="/block-list/demand">
                    <i class="fa-regular fa-circle" matTooltip="Demand Block List"></i>
                    <span>Demand Block List</span>
                  </a>
                </li>
              </ul>
            </mat-expansion-panel>
          </div>
          <div *csHasPermission="RolePermission.REPORTING_READ">
            <mat-expansion-panel class="mat-elevation-z0" [expanded]="false" >
              <mat-expansion-panel-header>
                <mat-panel-title class="sidenav-menu-item">
                  <i class="far fa-chart-line"></i>
                  Reporting
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                <!-- <li *csHasPermission="RolePermission.REPORTING_REPORT_BUILDER_READ">
                <a routerLink="/reports" routerLinkActive="active">
                  <i class="fa-regular fa-circle" matTooltip="Report Builder"></i>
                  <span>Report Builder</span>
                </a>
              </li> -->
              <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                <li *csHasPermission="RolePermission.REPORTING_REPORT_BUILDER_READ">
                  <a routerLink="/reports-explorer" routerLinkActive="active">
                    <i class="fa-regular fa-circle" matTooltip="Report Explorer"></i>
                    <span>Report Explorer</span>
                  </a>
                </li>
              </ul>
              <!-- <li *csHasPermission="RolePermission.REPORTING_PERFORMANCE_READ">
              <a routerLink="/performance" routerLinkActive="active">
                <i class="fa-regular fa-circle" matTooltip="Performance"></i>
                <span>Performance</span>
              </a>
            </li> -->
            <li *csHasPermission="RolePermission.REPORTING_SCHEDULED_REPORTS_READ">
              <a routerLink="/scheduled-reports" routerLinkActive="active"
                *csHasPermission="RolePermission.RB_SCHEDULE_CREATE">
                <i class="fa-regular fa-circle" matTooltip="Reports"></i>
                <span>Reports</span>
              </a>
            </li>
            <li>
              <a routerLink="/health-check" routerLinkActive="active">
                <i class="fa-regular fa-circle" matTooltip="Health Check"></i>
                <span>Health Check</span>
              </a>
            </li>
          </ul>
        </mat-expansion-panel>
      </div>
      <div *csHasPermission="RolePermission.TARGETING_READ">
        <div (click)="closeSidenavMobile(sidenav);">
          <a class="sidenav-menu-item" [routerLink]="['/', AppRoutePath.TARGETING]" routerLinkActive="active">
            <i class="far fa-users-viewfinder"></i>
            <span>Targeting</span>
          </a>
        </div>
      </div>
      <div *csHasPermission="RolePermission.ADMIN_READ">
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item">
              <i class="far fa-tools"></i>
              Admin
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li *csHasPermission="RolePermission.USERS_USERS_READ">
              <a routerLink="/users" routerLinkActive="active">
                <i class="fa-regular fa-circle" matTooltip="Users"></i>
                <span>Users</span>
              </a>
            </li>
            <!-- <li *csHasPermission="RolePermission.USERS_ROLES_READ">
            <a routerLink="/roles" routerLinkActive="active">
              <i class="fa-regular fa-circle" matTooltip="Roles"></i>
              <span>Roles</span>
            </a>
          </li> -->
          <li *csHasPermission="RolePermission.CHANGELOG_READ">
            <a routerLink="/changelog" routerLinkActive="active">
              <i class="fa-regular fa-circle" matTooltip="Changelog"></i>
              <span>Changelog</span>
            </a>
          </li>
        </ul>
      </mat-expansion-panel>
    </div>
    <div *csHasPermission="RolePermission.DEBUG_READ">
      <div (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
        <a class="sidenav-menu-item" routerLink="/debug" routerLinkActive="active">
          <i class="far fa-bug"></i>
          <span>Debug Mode</span>
        </a>
      </div>
    </div>
  </mat-accordion>
}
<!-- ADMIN USER END-->

<!--SUPER ADMIN USER START-->
@if (UI.isSuperAdmin) {
  <mat-accordion class="app-nav-accordion" #accordion="matAccordion" [multi]="false">
    <div *csHasPermission="RolePermission.HOME_READ">
      <div (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
        <a class="sidenav-menu-item" routerLink="/dashboard" routerLinkActive="active">
          <i class="far fa-house"></i>
          <span>Home</span>
        </a>
      </div>
    </div>
    <div *csHasPermission="RolePermission.HOME_READ">
      <div (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
        <a class="sidenav-menu-item" routerLink="/networks" routerLinkActive="active">
          <i class="fa-regular fa-network-wired"></i>
          <span>Networks</span>
        </a>
      </div>
    </div>
    <div *csHasPermission="RolePermission.AI_WEB_PLAYER_READ">
      <mat-expansion-panel class="mat-elevation-z0" [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title class="sidenav-menu-item">
            <i class="far fa-robot"></i>
            AI Web Player
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
          <li *csHasPermission="RolePermission.AI_WEB_PLAYER_DOMAINS_READ">
            <a routerLink="/ai-web-player" routerLinkActive="active">
              <i class="fa-regular fa-circle" matTooltip="Domains"></i>
              <span>Domains</span>
            </a>
          </li>
        </ul>
      </mat-expansion-panel>
    </div>
    <div *csHasPermission="RolePermission.REPORTING_READ">
      <mat-expansion-panel class="mat-elevation-z0" [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title class="sidenav-menu-item">
            <i class="far fa-chart-bar"></i>
            Reporting
          </mat-panel-title>
        </mat-expansion-panel-header>
        <!-- <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
        <li *csHasPermission="RolePermission.REPORTING_REPORT_BUILDER_READ">
          <a routerLink="/reports" routerLinkActive="active">
            <i class="fa-regular fa-circle" matTooltip="Report Builder"></i>
            <span>Report Builder</span>
          </a>
        </li>
      </ul> -->
      <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
        <li *csHasPermission="RolePermission.REPORTING_REPORT_BUILDER_READ">
          <a routerLink="/reports-explorer" routerLinkActive="active">
            <i class="fa-regular fa-circle" matTooltip="Report Explorer"></i>
            <span>Report Explorer</span>
          </a>
        </li>
      </ul>
    </mat-expansion-panel>
  </div>
  <div *csHasPermission="RolePermission.ADMIN_READ">
    <mat-expansion-panel class="mat-elevation-z0" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title class="sidenav-menu-item">
          <i class="far fa-tools"></i>
          Admin
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
        <li *csHasPermission="RolePermission.USERS_USERS_READ">
          <a routerLink="/users" routerLinkActive="active">
            <i class="fa-regular fa-circle" matTooltip="Users"></i>
            <span>Users</span>
          </a>
        </li>
        <li>
          <a routerLink="/health-check" routerLinkActive="active">
            <i class="fa-regular fa-circle" matTooltip="Health Check"></i>
            <span>Health Check</span>
          </a>
        </li>
      </ul>
    </mat-expansion-panel>
  </div>
  <div *csHasPermission="RolePermission.DEBUG_READ">
    <div (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
      <a class="sidenav-menu-item" routerLink="/debug" routerLinkActive="active">
        <i class="far fa-bug"></i>
        <span>Debug Mode</span>
      </a>
    </div>
  </div>
</mat-accordion>
}

</div>

</mat-sidenav>
</mat-sidenav-container>
